export const patientDetailsValidationMessage = {
  careType: [],
  firstName: [
    { type: "required", message: "First Name is required." },
    { type: "maxlength", message: "Maximum 50 characters are allowed." },
    {
      type: "pattern",
      message: "First name must only contain letters, space, -, or '",
    },
  ],
  middleInitial: [
    { type: "required", message: "Middle initial is required." },
    { type: "maxlength", message: "Maximum 2 characters are allowed." },
  ],
  lastName: [
    { type: "required", message: "Last Name is required." },
    { type: "maxlength", message: "Maximum 50 characters are allowed." },
    {
      type: "pattern",
      message: "Last name must only contain letters, space, -, or '",
    },
  ],
  nickname: [
    { type: "required", message: "Nickname is required." },
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  prefix: [
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  suffix: [
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  dateOfBirth: [{ type: "required", message: "Date of Birth is required." }],
  gender: [{ type: "required", message: "Gender is required." }],
  ssn: [
    { type: "required", message: "SSN is required." },
    { type: "pattern", message: "SSN is not in proper format." },
    { type: "notUnique", message: "SSN is not unique" },
  ],
  maritalStatus: [
    { type: "required", message: "Maritial Status is required." },
  ],
  firstLanguage: [
    { type: "required", message: "Preferred Language is required." },
  ],
  hisEthnicity: [
    { type: "required", message: "Ethnicity / Race (HIS) is required." },
  ],
  hopeEthnicity: [
    { type: "required", message: "Ethnicity (HOPE) is required." },
  ],
  hopeRace: [{ type: "required", message: "Race (HOPE) is required." }],
  veteran: [{ type: "required", message: "Veteran status is required." }],
  religion: [{ type: "required", message: "Religion is required." }],
  riskPriority: [{ type: "required", message: "Risk Priority is required." }],
  city: [
    { type: "required", message: "City is required." },
    { type: "maxlength", message: "Maximum 50 characters are allowed." },
  ],
  state: [{ type: "required", message: "State is required." }],
  address1: [
    { type: "required", message: "Street Address is required." },
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  zip: [
    { type: "required", message: "Zipcode is required." },
    { type: "pattern", message: "Must be 5 characters long." },
  ],
  zipExtension: [{ type: "pattern", message: "Must be 4 characters long." }],
  county: [{ type: "required", message: "County is required." }],
  phone: [
    { type: "required", message: "Phone Number is required." },
    { type: "pattern", message: "Phone Number is not in proper format." },
  ],
  emailAddress: [
    { type: "pattern", message: "Please enter email in valid format." },
  ],
  veteranNotes: [
    { type: "whitespace", message: "Notes are required if Veteran is Yes." },
  ],
};

export const referralLocationValidationMessage = {
  locationName: [{ type: "required", message: "Location Name is required." }],
};

export const providerValidationMessage = {
  firstName: [
    { type: "required", message: "First Name is required." },
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  lastName: [
    { type: "required", message: "Last Name is required." },
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  npi: [
    { type: "required", message: "NPI is required." },
    { type: "pattern", message: "NPI is not in proper format." },
  ],
  phone: [
    { type: "pattern", message: "Phone Number is not in proper format." },
  ],
  fax: [{ type: "pattern", message: "Fax Number is not in proper format." }],
  mobile: [{ type: "pattern", message: "Fax Number is not in proper format." }],
};

export const referringPhysicianValidationMessage = {
  firstName: [
    { type: "required", message: "First Name is required." },
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  lookupReferralCredit: [
    { type: "required", message: "Referral Credit is required." },
  ],
  lastName: [
    { type: "required", message: "Last Name is required." },
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  npi: [
    { type: "required", message: "NPI is required." },
    { type: "pattern", message: "NPI is not in proper format." },
  ],
  phone: [
    { type: "required", message: "Phone Number is required." },
    { type: "pattern", message: "Phone Number is not in proper format." },
  ],
  fax: [
    { type: "required", message: "Fax Number is required." },
    { type: "pattern", message: "Fax Number is not in proper format." },
  ],
  street: [
    { type: "required", message: "Street Address is required." },
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  city: [
    { type: "required", message: "City is required." },
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  zip: [
    { type: "required", message: "Zipcode is required." },
    { type: "pattern", message: "Must be 5 characters long." },
  ],
  zipExtension: [{ type: "pattern", message: "Must be 4 characters long." }],
  relation: [{ type: "required", message: "Relation is required." }],
  mobile: [
    { type: "pattern", message: "Mobile Number is not in proper format." },
  ],
  state: [{ type: "required", message: "State is required." }],
  streetAddress: [{ type: "required", message: "Street Address is required." }],
};

export const funeralHomeValidationMessage = {
  facilityName: [
    { type: "required", message: "Name is required." },
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  name: [
    { type: "required", message: "Name is required." },
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  phone: [
    { type: "required", message: "Phone Number is required." },
    { type: "pattern", message: "Phone Number is not in proper format." },
  ],
  zip: [{ type: "pattern", message: "Must be 5 characters long." }],
  zipExtension: [{ type: "pattern", message: "Must be 4 characters long." }],
  emailAddress: [
    { type: "pattern", message: "Please enter email in valid format." },
  ],
};

export const callerValidationMessage = {
  firstName: [
    { type: "required", message: "First Name is required." },
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  referralType: [{ type: "required", message: "Referral Type is required." }],
  relationType: [{ type: "required", message: "Relation Type is required." }],
  lastName: [
    { type: "required", message: "Last Name is required." },
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  phone: [
    { type: "required", message: "Phone Number is required." },
    { type: "pattern", message: "Phone Number is not in proper format." },
  ],
  mobile: [
    { type: "pattern", message: "Mobile Number is not in proper format." },
  ],
  fax: [
    { type: "required", message: "Fax Number is required." },
    { type: "pattern", message: "Fax Number is not in proper format." },
  ],
  email: [{ type: "pattern", message: "Please enter email in valid format." }],
  npi: [
    { type: "required", message: "NPI is required." },
    { type: "pattern", message: "NPI is not in proper format." },
  ],
  streetAddress: [{ type: "required", message: "Street Address is required." }],
  city: [{ type: "required", message: "City is required." }],
  zip: [
    { type: "required", message: "Zipcode  is required." },
    { type: "pattern", message: "Must be 5 characters long." },
  ],
  zipExtension: [{ type: "pattern", message: "Must be 4 characters long." }],
  state: [{ type: "required", message: "State is required." }],
};

export const referrerValidationMessage = {
  firstName: [
    { type: "required", message: "First Name is required." },
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  relation: [{ type: "required", message: "Relation is required." }],
  lastName: [
    { type: "required", message: "Last Name is required." },
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
  ],
  npi: [
    { type: "required", message: "NPI is required." },
    { type: "pattern", message: "NPI is not in proper format." },
  ],
  phone: [
    { type: "required", message: "Phone Number is required." },
    { type: "pattern", message: "Phone Number is not in proper format." },
  ],
  mobile: [
    { type: "pattern", message: "Mobile Number is not in proper format." },
  ],
  fax: [
    { type: "required", message: "Fax Number is required." },
    { type: "pattern", message: "Fax Number is not in proper format." },
  ],
  emailAddress: [
    { type: "pattern", message: "Please enter email in valid format." },
  ],
  address1: [{ type: "required", message: "Street Address is required." }],
  city: [{ type: "required", message: "City is required." }],
  zip: [
    { type: "required", message: "Zipcode is required." },
    { type: "pattern", message: "Must be 5 characters long." },
  ],
  zipExtension: [{ type: "pattern", message: "Must be 4 characters long." }],
  state: [{ type: "required", message: "State is required." }],
};

export const hospiceTransferValidationMessage = {
  transferDate: [{ type: "required", message: "Transfer Date is required." }],
  locationType: [{ type: "required", message: "Location Type is required." }],
  name: [{ type: "required", message: "Name is required." }],
  streetAddress: [{ type: "required", message: "Street address is required." }],
  city: [{ type: "required", message: "City is required." }],
  state: [{ type: "required", message: "State is required." }],
  previousHospiceProviderNumber: [
    { type: "pattern", message: "NPI Must be 10 digits." },
    { type: "required", message: "Previous hospice NPI number is required." },
  ],
  phone: [
    { type: "pattern", message: "Phone Number is not in proper format." },
  ],
  fax: [
    { type: "required", message: "Fax Number is required." },
    { type: "pattern", message: "Fax Number is not in proper format." },
  ],
  zip: [
    { type: "required", message: "Zipcode is required." },
    { type: "pattern", message: "Must be 5 characters long." },
  ],
  zipExtension: [{ type: "pattern", message: "Must be 4 characters long." }],
  emailAddress: [
    { type: "pattern", message: "Please enter email in valid format." },
  ],
};

export const levelOfCareValidationMessage = {
  levelOfCareLocation: [
    { type: "required", message: "Level of care location is required." },
  ],
  startDate: [{ type: "required", message: "Start Date is required." }],
  careLocationType: [
    {
      type: "required",
      message: "Care location type is required.",
    },
  ],
  symptoms: [
    {
      type: "required",
      message: "Symptoms must be selected for Continuous Care.",
    },
  ],
  reasonsForGIP: [
    {
      type: "required",
      message: "Reason(s) must be selected for GIP.",
    },
  ],
  careLocationName: [
    {
      type: "required",
      message: "Facility must be selected when care location is not home.",
    },
  ],
};

export const benefitValidationMessage = {
  payerType: [{ type: "required", message: "Payer type is required." }],
  payerName: [{ type: "required", message: "Payer name is required." }],
  effectiveDate: [{ type: "required", message: "Effective date is required." }],
  subscriberId: [
    {
      type: "required",
      message: "Subscriber Id is required.",
    },
    {
      type: "pattern",
      message: "Invalid MBI Format. Correct format example: 1EG4TE5MK73",
    },
  ],
  firstName: [
    {
      type: "required",
      message: "Subscriber First name is required.",
    },
  ],
  lastName: [
    {
      type: "required",
      message: "Subscriber Last name is required.",
    },
  ],
  birthDate: [
    {
      type: "required",
      message: "Subscriber birth date is required.",
    },
  ],
  patientRelationshipsMessage: [
    {
      type: "required",
      message: "Patient Relationship to Insured is required.",
    },
  ],
  admitBenefitPeriod: [
    {
      type: "required",
      message: "Admit Benefit Period is required.",
    },
    {
      type: "pattern",
      message: "Admit Benefit Period must be 1-99.",
    },
  ],
  admitHospiceEpisode: [
    {
      type: "required",
      message: "Admit Hospice Episode is required.",
    },
    {
      type: "pattern",
      message: "Admit Hospice Episode must be 1-9999.",
    },
  ],
  admitBenefitPeriodStart: [
    {
      type: "required",
      message: "Admit benefit period start date is required.",
    },
  ],
  latestRevocationDateError: [
    {
      type: "required",
      message: "Latest Revocation Date is required",
    },
    {
      type: "invalidDate",
      message:
        "Latest Revocation Date must be after the previous hospice election date.",
    },
  ],
  hospiceDateErrors: [
    {
      type: "invalidDate",
      message: "Previous Hospice Election Date must be before current date.",
    },
  ],
};

export const communicationNoteValidationMessage = {
  subject: [{ type: "required", message: "Subject is required." }],
  note: [{ type: "required", message: "Notes are required." }],
  startDate: [
    { type: "required", message: "Start Date is required." },
    { type: "invalidDate", message: "Start Date must be before End Date." },
  ],
  startTime: [{ type: "required", message: "Start Time is required." }],
  endDate: [{ type: "required", message: "End Date is required." }],
  endTime: [{ type: "required", message: "End Time is required." }],
};

export const intakeNotesValidationMessage = {
  subject: [{ type: "required", message: "Subject is required." }],
  note: [{ type: "required", message: "Notes are required." }],
  startDate: [
    { type: "required", message: "Start Date is required." },
    { type: "invalidDate", message: "Start Date must be before End Date." },
  ],
  startTime: [{ type: "required", message: "Start Time is required." }],
  endDate: [{ type: "required", message: "End Date is required." }],
  endTime: [{ type: "required", message: "End Time is required." }],
};

export const encountersValidationMessage = {
  subject: [{ type: "required", message: "Subject is required." }],
  note: [{ type: "required", message: "Notes are required." }],
  startDate: [
    { type: "required", message: "Start Date is required." },
    { type: "invalidDate", message: "Start Date must be before End Date." },
  ],
  startTime: [{ type: "required", message: "Start Time is required." }],
  endDate: [{ type: "required", message: "End Date is required." }],
  endTime: [{ type: "required", message: "End Time is required." }],
};

export const adverseEventValidationMessage = {
  category: [{ type: "required", message: "Category is required." }],
  event: [
    {
      type: "required",
      message1: "Please select Category first.",
      message2: "Event is required.",
    },
  ],
  reportedBy: [{ type: "required", message: "Reported By is required." }],
  narrative: [{ type: "required", message: "Narrative is required." }],
  actionNote: [
    {
      type: "required",
      message: "Please specify action taken or why no action was taken.",
    },
  ],
};

export const dischargeStatusValidationMessage = {
  dateOfDischarge: [
    { type: "required", message: "Date Of Discharge is required." },
  ],
  locationType: [{ type: "required", message: "Location Type is required." }],
  name: [{ type: "required", message: "Name is required." }],
  phone: [
    { type: "pattern", message: "Phone Number is not in proper format." },
  ],
  fax: [
    { type: "required", message: "Fax Number is required." },
    { type: "pattern", message: "Fax Number is not in proper format." },
  ],
};
export const addMedicationValidationMessage = {
  other: [
    { type: "maxlength", message: "Maximum 100 characters are allowed." },
  ],
  issue: [
    { type: "maxlength", message: "Maximum 500 characters are allowed." },
  ],
  symptoms: [
    { type: "maxlength", message: "Maximum 500 characters are allowed." },
  ],
  name: [{ type: "required", message: "Name is required." }],
  doseform: [
    { type: "required", message: "Dose Form is required." },
    { type: "maxlength", message: "Maximum 100 characters are allowed." },
  ],
  route: [
    { type: "required", message: "Dose Form is required." },
    { type: "maxlength", message: "Maximum 100 characters are allowed." },
  ],
  strength: [
    { type: "required", message: "Strength is required." },
    { type: "maxlength", message: "Maximum 100 characters are allowed." },
  ],
  parameterForDosage: [
    { type: "required", message: "Parameter For Dosage is required." },
  ],
  frequency: [
    { type: "required", message: "Frequency is required." },
    { type: "maxlength", message: "Maximum 100 characters are allowed." },
  ],
  dosage: [
    { type: "required", message: "Dosage is required." },
    { type: "maxlength", message: "Maximum 100 characters are allowed." },
  ],
  description: [
    { type: "maxlength", message: "Maximum 1000 characters are allowed." },
  ],
};
export const addAllergyValidationMessage = {
  name: [{ type: "maxlength", message: "Maximum 500 characters are allowed." }],
  notes: [
    { type: "maxlength", message: "Maximum 1000 characters are allowed." },
  ],
};
export const addDMEValidationMessage = {
  other: [
    { type: "maxlength", message: "Maximum 100 characters are allowed." },
  ],
  issue: [
    { type: "maxlength", message: "Maximum 500 characters are allowed." },
  ],
  dmeType: [
    { type: "required", message: "DME Type is required." },
    { type: "maxlength", message: "Maximum 300 characters are allowed." },
  ],
  startDate: [
    {
      type: "validation",
      message: "Start date should be less than D/C date.",
    },
    { type: "required", message: "Start  is required." },
  ],
  dcDate: [
    {
      type: "validation",
      message: "D/C date should be greater than Start Date.",
    },
  ],
};
export const orderReportsValidationMessage = {
  startDate: [
    {
      type: "validation",
      message: "Start date should be less than End date.",
    },
  ],
  endDate: [
    {
      type: "validation",
      message: "End date should be greater than Start Date.",
    },
  ],
  dateSpanOneWeek: [
    {
      type: "validation",
      message: "Date range should be maximum of 1 week.",
    },
  ],
};
export const vmValidationMessage = {
  travelMinutes: [
    {
      type: "min",
      message: "Minimum required number is 0.",
    },
    {
      type: "max",
      message: "Maximum number can be 180.",
    },
  ],
  mileage: [
    {
      type: "pattern",
      message: "Invalid Number (eg: 000.000)",
    },
    {
      type: "max",
      message: "Mileage cannot be greater than 999",
    },
  ],
  activityNotes: [
    {
      type: "maxlength",
      message: "Notes can be max 1000 characters long.",
    },
  ],
  other3: [
    {
      type: "maxlength",
      message: "Maximum 75 characters are allowed.",
    },
    { type: "required", message: "Other is required." },
    { type: "pattern", message: "Only alphanumeric characters are allowed." },
  ],
  other16: [
    {
      type: "maxlength",
      message: "Maximum 75 characters are allowed.",
    },
    { type: "required", message: "Other is required." },
    { type: "pattern", message: "Only alphanumeric characters are allowed." },
  ],
  electSignedBy: [{ type: "required", message: "Signed by is required." }],
};
export const communityBereavedValidationMessage = {
  checkpointName: [
    { type: "required", message: "Checkpoint Name is required." },
    { type: "maxlength", message: "Maximum 50 characters are allowed." },
    {
      type: "pattern",
      message: "Checkpoint name must only contain letters, space, -, or '",
    },
  ],
  status: [{ type: "required", message: "Status is required." }],
  dueDate: [{ type: "required", message: "Due Date is required." }],
  dateOfAction: [{ type: "required", message: "Date of Action is required." }],
  completedBy: [{ type: "required", message: "Completed By is required." }],
  note: [{ type: "required", message: "Notes are required." }],
};
export const patientHistoryValidationMessage = {
  subject: [{ type: "required", message: "Subject is required." }],
  dateOfEvent: [{ type: "required", message: "Date of Event is required." }],
  description: [{ type: "required", message: "Description is required." }],
};



// WEBPACK FOOTER //
// ./src/validators/validationMessages.ts